<template lang="pug">
yz-dialog(:value="open" max-width="520" persistent @input="onClose")
  yz-card
    yz-dialog-normal-header(title="Unable to activate package" @close="onClose")
    .pa-6
      .yz-regular-body-sm.text-neutral-500 The following treatments have an invalid unit of measure. Please edit the package and update the unit before activating.
      yz-simple-table.mt-4
        template(v-slot:default)
          thead
            tr
              th.yz-bold-body-xs.text-neutral-700 Treatment
              th.yz-bold-body-xs.text-neutral-700 Current unit
              th.yz-bold-body-xs.text-neutral-700 Available units
          tbody
            tr(v-for="t in treatments" :key="t.name")
              td.py-2
                .yz-regular-body-sm.text-neutral-700 {{ t.name }}
              td.py-2
                .yz-regular-body-sm.text-danger-500 {{ t.currentUom }}
              td.py-2
                .yz-regular-body-sm.text-neutral-500 {{ t.availableUoms }}
    yz-dialog-normal-actions(save-label="Got it" cancel-label="" disable-cancel @save="onClose")
</template>

<script>
export default {
  props: {
    open: { type: Boolean, default: false },
    treatments: { type: Array, default: () => [] }
  },
  methods: {
    onClose () {
      this.$emit('update:open', false)
    }
  }
}
</script>
